"use client"

import { ReactNotifications, registerTimeAgoLocales } from "@alpheya/common"
import { FlowbiteContext } from "@quantum-wealth/dionysus-ui"
import { PropsWithChildren } from "react"
import { appTheme } from "@/flowbite-theme"

registerTimeAgoLocales()

export function AppClientWrapper({ children }: PropsWithChildren) {
  return (
    <FlowbiteContext customTheme={appTheme}>
      <ReactNotifications />
      {children}
    </FlowbiteContext>
  )
}
